import FormattedMessage from 'I18n/components/FormattedMessage';
import { EnrichmentPropertiesEmpty } from './EnrichmentPropertiesEmpty';
import { EnrichmentPropertiesError } from './EnrichmentPropertiesError';
import { EnrichmentPropertiesTable } from './EnrichmentPropertiesTable';
import { Body, Heading, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { useEnrichmentProperties } from './useEnrichmentProperties';
import { EnrichmentSettingsNudge } from './EnrichmentSettingsNudge';
import { UsageAlert } from '../Usage/UsageAlert';
import { BasePanel } from '../Panel/BasePanel';
import { PanelUsageEnrichment } from '../Panel/PanelUsageEnrichment';
import { PanelLoading } from '../Panel/PanelLoading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EnrichmentPropertiesBody() {
  const {
    isLoading,
    onSelect,
    properties,
    propertiesCount,
    selectedProperties
  } = useEnrichmentProperties();
  const action = 'DATASET_ENRICHMENT';
  const numberOfOperations = 1;
  return /*#__PURE__*/_jsx(PanelLoading, {
    isLoading: isLoading,
    children: /*#__PURE__*/_jsx(EnrichmentPropertiesError, {
      children: /*#__PURE__*/_jsx(EnrichmentPropertiesEmpty, {
        children: /*#__PURE__*/_jsx(BasePanel.Body, {
          children: /*#__PURE__*/_jsxs(BasePanel.Content, {
            paddingBlockStart: "space-md",
            children: [/*#__PURE__*/_jsxs(LayoutSpaceVertical, {
              as: "header",
              marginBlockEnd: "space-xl",
              children: [/*#__PURE__*/_jsx(UsageAlert, {
                action: action,
                numberOfOperations: numberOfOperations
              }), /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
                as: "header",
                gap: "space-xs",
                maxInlineSize: "70ch",
                children: [/*#__PURE__*/_jsx(Heading, {
                  as: "h5",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "enrichmentProperties.panel.header.title",
                    options: {
                      count: propertiesCount
                    }
                  })
                }), /*#__PURE__*/_jsx(Body, {
                  as: "div",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "enrichmentProperties.panel.header.description"
                  })
                })]
              }), /*#__PURE__*/_jsx(PanelUsageEnrichment, {
                numberOfOperations: numberOfOperations
              }), /*#__PURE__*/_jsx(EnrichmentSettingsNudge, {})]
            }), /*#__PURE__*/_jsx(EnrichmentPropertiesTable, {
              onSelect: onSelect,
              properties: properties,
              selectedProperties: selectedProperties
            })]
          })
        })
      })
    })
  });
}